import PropTypes from 'prop-types';
import React, { PureComponent, Component } from 'react';

// Positioner provides functions for positioning elements inside an Artboard
const Positioner = ({ imageSize, viewSize, scale, render }) => {
    const scaledImageSize = {
        width: imageSize.width * scale,
        height: imageSize.height * scale,
    };
    // Artboard needs to be at least as big as the visible viewport to recieve mouse events for annotating / sketching etc
    const artboardSize = {
        width: Math.max(scaledImageSize.width, viewSize.width),
        height: Math.max(scaledImageSize.height, viewSize.height),
    };
    // Center the image inside the artboard
    const artboardOrigin = {
        x: (artboardSize.width - scaledImageSize.width) / 2,
        y: (artboardSize.height - scaledImageSize.height) / 2,
    };

    // Convert image coordinates to screen coordinates
    const imageToScreen = ({ x, y }) => ({
        x: x * scale + artboardOrigin.x,
        y: y * scale + artboardOrigin.y,
    });

    // Convert screen coordinates back to image coordinates (useful for mouse handlers)
    const screenToImage = ({ x, y }) => ({
        x: (x - artboardOrigin.x) / scale,
        y: (y - artboardOrigin.y) / scale,
    });

    return render({
        artboardSize,
        artboardOrigin,
        scaledImageSize,
        imageToScreen,
        screenToImage,
    });
};

export default Positioner;



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/DesignPane/Positioner.jsx